import React from "react"
import { useTranslation } from "react-i18next"
import { useDispatch } from "react-redux"
import { useHistory, useLocation } from "react-router-dom"
import { FaChevronLeft, FaChevronRight } from "react-icons/fa"
import clsx from "clsx"

import { Button } from "components"
import { isDirectionLtr } from "utils"
import { changeCinemaSolon } from "@redux"
import classes from "./index.module.scss"

const solons = [
  { label: "عطار", image: "/assets/images/attar.jpg" },
  { label: "فردوسی", image: "/assets/images/ferdowsi.jpg" },
  { label: "رودکی", image: "/assets/images/rudaki.jpg" },
  { label: "خیام", image: "/assets/images/khayam.jpg" }
]

const KioskCinemaSolons = () => {
  const [t, i18n] = useTranslation()

  const dispatch = useDispatch()

  const history = useHistory()

  const location = useLocation()

  const handleGoBack = () => {
    const route =
      location.state?.redirectFrom ||
      "/kiosk-delivery-types"

    history.push(route)
  }

  const handleClick = (cinemaSolon) => {
    dispatch(
      changeCinemaSolon(cinemaSolon)
    )

    const route =
      location.state?.redirectFrom ||
      "/kiosk-foods"

    history.push(route)
  }

  const isLtr =
    isDirectionLtr(i18n.language)

  return (
    <div className={classes["container"]}>
      <div className={classes["header"]}>
        <Button
          className={classes["button"]}
          onClick={handleGoBack}
        >
          {isLtr ? <FaChevronLeft size={18} /> : <FaChevronRight size={18} />}

          <span
            className={clsx(
              classes["text"],
              isLtr && classes["text-ltr"]
            )}
          >
            {t("بازگشت")}
          </span>
        </Button>
      </div>

      <div className={classes["title"]}>
        {t("لطفا_سالن_سینما_موردنظر_را_انتخاب_کنید")}
      </div>

      <div className={classes["row-container"]}>
        <div className={classes["row"]}>
          {solons.map(solon =>
            <div
              key={solon.label}
              className={classes["card"]}
            >
              <div
                key={solon.label}
                onClick={() => handleClick(solon.label)}
                className={classes["image-container"]}
              >
                <img
                  src={solon.image}
                  alt={solon.label}
                  className={classes["image"]}
                />
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}

export default KioskCinemaSolons